import React from "react";
import TrapSeven from "../../../assets/img/trape-seven.png";
import { formatBook } from "../../../utils/formatOdds";

const REMARK_ICON = `${import.meta.env.BASE_URL}assets/img/icons/remark.png`;

/**
 * 1 CARD ONE-DAY (teen1) bet table in the reference admin's markup — rendered inside the page's `.casino-detail`:
 *   .teen1daycasino-container (Player | Dealer: .casino-box-row with book + back/lay)
 *   + .teen1daycasino-container (Player | Dealer: .seven-up-down-box DOWN / UP + 7 image)
 *   + .casino-remark (only when the feed has a non-empty remark)
 * Styled by the ported reference rules in styles/index.css.
 *
 * Markets like the reference: main = sub{subtype:"teen1"} by sr (0 Player, 1 Dealer),
 * upDown = sub{subtype:"updown"} by sr (0 7 Up Player, 1 7 Down Player, 2 7 Up Dealer, 3 7 Down Dealer).
 */
export default function BetTableTeen1({ data = [], onBetClick, exposures = {}, remark }) {
  const list = Array.isArray(data) ? data : [];
  const bySr = (a, b) => Number(a?.sr) - Number(b?.sr);
  const main = list.filter((s) => s?.subtype === "teen1").sort(bySr);
  const upDown = list.filter((s) => s?.subtype === "updown").sort(bySr);
  const mainAt = (i, name) => main[i] || list.find((s) => s?.nat === name) || { nat: name };
  const udAt = (i, name) => upDown[i] || list.find((s) => s?.nat === name) || { nat: name };

  const isSuspended = (b) => String(b?.gstatus || "").toUpperCase() !== "OPEN";
  const show = (v) => (v !== undefined && v !== null && v !== "" ? v : 0);
  const getExposure = (name) => {
    const v = exposures[name] ?? exposures[name?.toLowerCase?.()];
    return v != null ? Number(v) || 0 : 0;
  };
  // Reference v-casinobook / v-casinofancybook: amount > 0 → book-green, otherwise book-red
  const bookClass = (exp) => (exp > 0 ? "book-green" : "book-red");
  const click = (b, type) => {
    if (isSuspended(b)) return;
    const value = type === "lay" ? b?.l : b?.b;
    if (!value) return;
    onBetClick?.(value, b?.nat, b, type);
  };

  const mainSide = (b, label) => {
    const exp = getExposure(b?.nat ?? label);
    const sus = isSuspended(b) ? " suspended" : "";
    return (
      <div className="casino-box-row">
        <div className="casino-nation-name">
          <b>{label}</b>{" "}
          <div className="float-right">
            <span className={`mr-2 ${bookClass(exp)}`}>{formatBook(exp)}</span>
          </div>
        </div>{" "}
        <div className="casino-bl-box">
          <div className={`back casino-bl-box-item${sus}`} onClick={() => click(b, "back")}>
            <span className="casino-box-odd">{show(b?.b)}</span>
          </div>{" "}
          <div className={`lay casino-bl-box-item${sus}`} onClick={() => click(b, "lay")}>
            <span className="casino-box-odd">{show(b?.l)}</span>
          </div>
        </div>
      </div>
    );
  };

  // Reference directive adds .lock-top to a suspended parent of the book element
  const udBox = (cls, b, label, align) => {
    const exp = getExposure(b?.nat);
    const sus = isSuspended(b) ? " suspended lock-top" : "";
    return (
      <div className={`${cls}${sus}`} onClick={() => click(b, "back")}>
        <div className={`up-down-book ${bookClass(exp)}`}>{formatBook(exp)}</div>{" "}
        <div className={align}>
          <div className="up-down-odds">{show(b?.b)}</div> <span>{label}</span>
        </div>
      </div>
    );
  };

  const sevenBox = (down, up) => (
    <div className="seven-up-down-box">
      {udBox("up-box", down, "DOWN", "text-right")}{" "}
      {udBox("down-box", up, "UP", "text-left")}{" "}
      <div className="seven-box">
        <img src={TrapSeven} alt="" />
      </div>
    </div>
  );

  return (
    <>
      <div className="teen1daycasino-container">
        <div className="teen1dayleft">{mainSide(mainAt(0, "Player"), "Player")}</div>{" "}
        <div className="teen1daycenter" />{" "}
        <div className="teen1dayright">{mainSide(mainAt(1, "Dealer"), "Dealer")}</div>
      </div>{" "}
      <div className="teen1daycasino-container">
        <div className="teen1dayleft">{sevenBox(udAt(1, "7 Down Player"), udAt(0, "7 Up Player"))}</div>{" "}
        <div className="teen1daycenter" />{" "}
        <div className="teen1dayright">{sevenBox(udAt(3, "7 Down Dealer"), udAt(2, "7 Up Dealer"))}</div>
      </div>
      {remark != null && remark !== "" && (
        <div className="casino-remark mt-3">
          <div className="remark-icon">
            <img src={REMARK_ICON} alt="" />
          </div>{" "}
          {React.createElement("marquee", null, remark)}
        </div>
      )}
    </>
  );
}
